import {newQuestion} from '../../actions/library/questions'
import {newSet} from '../../actions/library/sets'

export function makeACopyQuestion(currentQuestion) {
	const nowDate = new Date()
	let copyOfQuestion={...currentQuestion}
	const newBody=`Copy of ${currentQuestion.body}`

	copyOfQuestion.body=newBody
	copyOfQuestion.clientModified=nowDate
	copyOfQuestion.userCreated=nowDate


	 return newQuestion(copyOfQuestion)

}



export function makeACopySet(currentSet) {
	const nowDate = new Date()
	let copyOfSet=currentSet
	const newName=`Copy of ${currentSet.name}`

	copyOfSet.name=newName
	copyOfSet.clientModified=nowDate
	copyOfSet.userCreated=nowDate
	return newSet(copyOfSet)
}



